import { render, staticRenderFns } from "./MainUserInfo.vue?vue&type=template&id=912dd118&scoped=true&"
import script from "./MainUserInfo.vue?vue&type=script&lang=js&"
export * from "./MainUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./MainUserInfo.vue?vue&type=style&index=0&id=912dd118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912dd118",
  null
  
)

export default component.exports